<template>
  <div class="bg" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF" :curname="roomActiveName"></home-header>
    <div class="appointbox">
      <div class="appointleft">
        <ul>
          <li
            v-for="(i, index) in roomList"
            :key="index"
            @click="checkroom(index)"
            v-bind:class="{ active: roomlistActive === index }"
          >
            <img class="navbtn" src="../assets/navbutton.png" alt="" />
            <div class="roomName">{{ i.name }}</div>
            <span class="righttop">
              <span class="triangle"></span>
              <img src="../assets/gou.png" alt="" />
            </span>
          </li>
        </ul>
      </div>
      <div class="appointright">
        <div class="weekleft">
          <div class="timetitle">
            时间
          </div>
          <div class="weekbox">
            <ul>
              <li v-for="(i, index) in timeData" :key="index">
                <div>{{ i.date }}</div>
                <div>{{ i.day }}</div>
              </li>
            </ul>
          </div>
          <div class="nextweek" @click="nextWeek" v-if="nextWeektrue">
            <span>下周</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="nextweek" @click="beforeWeek" v-if="!nextWeektrue">
            <span>上周</span>
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="weektime">
          <!-- <div class="timeheader">
            <div class="timeheadli" v-for="(i,index) in headData" :key="index">{{i}}</div>
          </div> -->
          <div class="appointTable">
            <el-table
              :data="timeData"
              style="width: 100%"
              :header-cell-style="{
                'text-align': 'center',
                background: 'rgba(255,255,255,0.2)',
                color: '#fff',
                fontSize: '24px',
                padding: '18px'
              }"
              :cell-style="{ 'text-align': 'center', color: '#fff' }"
            >
              <el-table-column
                :label="time"
                width="136px"
                v-for="(time, key) in headData"
                :render-header="labelHead"
                :key="key"
              >
                <template slot-scope="scope">
                  <div
                    class="timestate inavailable"
                    v-if="timeData[scope.$index].freetime[key] === '0'"
                  >
                    <div style="height:68px"></div>
                  </div>
                  <div
                    class="timestate available"
                    v-if="timeData[scope.$index].freetime[key] === '1'"
                  >
                    <div style="height:68px"></div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="appointBottom">
            <div class="imgDemo">
              <span class="timedemo inavailable"></span>
              <span>不可约</span>
            </div>
            <!-- <div class="imgDemo">
              <span class="timedemo myMeeting"></span>
              <span>我的会议</span>
            </div> -->
            <div class="imgDemo">
              <span class="timedemo available"></span>
              <span>可预约</span>
            </div>
          </div>
        </div>
      </div>
      <div class="nextStep" @click="nextStep" v-if="nexttip">预约</div>
      <!-- <div class="aready" @click="finalappointSubmit" v-if="aready">完成</div> -->
    </div>
    <el-drawer :visible.sync="appointVisible" :with-header="false" size="65%">
      <div class="appointDrawer">
        <div class="appointCon">
          <div class="appointTitle">
            创建会议：
          </div>
          <div class="meetingRoom">{{ roomActiveName }}</div>
          <div class="centerline"></div>
          <div class="meetingCheck">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="3%"
              class="demo-ruleForm"
            >
              <el-form-item>
                <div class="labelname">
                  <img src="../assets/appointment.png" alt="" />
                  <span>预约人</span>
                </div>
                <div class="labelright">
                  <el-col :span="11" style="margin-right:20px;">
                    <el-form-item prop="appointmenter">
                      <el-input
                        v-model="ruleForm.appointmenter"
                        placeholder="请输入预约人姓名"
                      >
                        <i
                          slot="prefix"
                          class="el-input__icon el-icon-s-custom"
                        ></i>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item prop="telephone">
                      <el-input
                        v-model="ruleForm.telephone"
                        placeholder="请输入预约人电话"
                        onkeyup="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
                      >
                        <i
                          slot="prefix"
                          class="el-input__icon el-icon-phone"
                        ></i>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="labelname">
                  <img src="../assets/label.png" alt="" />
                  <span>时间选择</span>
                </div>
                <div class="labelright">
                  <el-col :span="11">
                    <el-form-item prop="date1">
                      <el-date-picker
                        v-model="ruleForm.date1"
                        type="datetime"
                        placeholder="选择开始时间"
                        :picker-options="pickerOptions"
                        class="picker-class"
                        format="yyyy-MM-dd HH:mm"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="1">至</el-col>
                  <el-col :span="11">
                    <el-form-item prop="date2">
                      <el-date-picker
                        v-model="ruleForm.date2"
                        type="datetime"
                        placeholder="选择结束时间"
                        :picker-options="pickerOptions"
                        class="picker-class"
                        format="yyyy-MM-dd HH:mm"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24"
                    ><div style="color:#F56C6C; line-height: 15px;">
                      {{ timeMsg }}
                    </div></el-col
                  >
                </div>
              </el-form-item>
              <el-form-item prop="theme">
                <div class="labelname">
                  <img src="../assets/theme.png" alt="" /><span>会议主题</span>
                </div>
                <div class="labelright">
                  <el-input
                    v-model="ruleForm.theme"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入会议主题"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item prop="department">
                <div class="labelname">
                  <img src="../assets/department.png" alt="" /><span
                    >主办单位</span
                  >
                </div>
                <div class="labelright">
                  <el-input v-model="ruleForm.department"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="labelname">
                  <img src="../assets/message.png" alt="" /><span
                    >通知参会人员</span
                  >
                </div>
                <div class="labelright messageAppoint">
                  <span>{{ appointmenterString }}</span>
                  <i
                    class="el-icon-circle-plus-outline"
                    @click="addAppointShow"
                  ></i>
                </div>
              </el-form-item>
              <div class="appointBtn" @click="appointSubmit('ruleForm')">
                确定
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <el-drawer
        :append-to-body="true"
        :with-header="false"
        :visible.sync="innerVisible2"
        size="40%"
      >
        <div class="appointDrawer addappointDrawer">
          <div class="appointCon">
            <div class="appointTitle">
              <i class="el-icon-arrow-left" @click="innerVisible2 = false"></i>
              <span>选择参会人员：</span>
            </div>
            <div class="meetingRoom">{{ roomActiveName }}</div>
            <div class="centerline"></div>
            <div class="meetingCheck addcheckappointment">
              <el-form class="addappointmenterform">
                <ul>
                  <li>
                    <el-col :span="10" style="margin-right:10px;">
                      <el-form-item prop="name">
                        <el-input
                          placeholder="姓名"
                          v-model="addAppoint.name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col  class="line" :span="2">~</el-col> -->
                    <el-col :span="10">
                      <el-form-item prop="telphone">
                        <el-input
                          placeholder="电话"
                          v-model="addAppoint.telephone"
                          onkeyup="value=value.replace(/[^\d]/g,'')"
                          maxlength="11"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2" class="appointAddbtn">
                      <el-form-item>
                        <el-button type="primary" @click="appointAddfun"
                          >添加</el-button
                        >
                      </el-form-item>
                    </el-col>
                  </li>
                </ul>
              </el-form>
              <el-form class="addcheckappointmentlist">
                <div class="noapenter" v-if="appointments2.length === 0">
                  请添加参会人
                </div>
                <ul>
                  <li v-for="(i, index) in appointments2" :key="index">
                    <el-col :span="10" style="margin-right:10px;">
                      <el-form-item prop="name">
                        <el-input
                          placeholder="姓名"
                          v-model="i.attendeeName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col  class="line" :span="2"></el-col> -->
                    <el-col :span="10">
                      <el-form-item prop="telphone">
                        <el-input
                          placeholder="电话"
                          v-model="i.attendeeTel"
                          onkeyup="value=value.replace(/[^\d]/g,'')"
                          maxlength="11"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2" class="appointAddbtn">
                      <el-form-item>
                        <el-button type="danger" @click="deleteAppoint(index)"
                          >删除</el-button
                        >
                      </el-form-item>
                    </el-col>
                  </li>
                </ul>
              </el-form>
            </div>
            <div class="appointBtn" @click="submitAppointment">确定</div>
          </div>
        </div>
      </el-drawer>
      <el-drawer
        :append-to-body="true"
        :with-header="false"
        :visible.sync="innerVisible"
        size="45%"
      >
        <div class="appointDrawer">
          <div class="appointCon">
            <div class="appointTitle">
              <i class="el-icon-arrow-left" @click="innerVisible = false"></i>
              <span>选择参会人员：</span>
            </div>
            <div class="meetingRoom">{{ roomActiveName }}</div>
            <div class="centerline"></div>
            <div class="meetingCheck checkappointment">
              <ul>
                <li v-for="(i, index) in appointments" :key="index">
                  <img :src="i.img" alt="" />
                  <div class="appointmentName">{{ i.name }}</div>
                  <el-checkbox v-model="i.checked"></el-checkbox>
                </li>
              </ul>
            </div>
            <div class="appointBtn" @click="submitAppointment">确定</div>
          </div>
        </div>
      </el-drawer>
    </el-drawer>
  </div>
</template>

<script>
import HomeHeader from "./header";
import { Toastinit } from "@/utils/toast";
import {
  meetingLists,
  timeStatus,
  addOrders,
  atPresent,
  findMeetingTime,
  getMeetModel
} from "@/utils/request";
import moment from "moment";
export default {
  name: "appoint",
  components: {
    HomeHeader
  },
  data() {
    const validateFun1 = (rule, value, callback) => {
      if (!value) {
        this.timeMsg = "";
      } else {
        this.checkTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
        if (this.meetingId !== "") {
          const query = {
            meetingId: this.meetingId,
            startTime: this.checkTime,
            endTime: this.checkTime2
          };
          findMeetingTime(query).then(res => {
            console.log(res);
            // if (res.msg === "success" || res.msg !== "") {
            //   callback();
            // }
            if (Number(res.code) === 1000) {
              this.timeMsg = res.msg;
            } else {
              this.timeMsg = "";
              callback();
            }
          });
        }
      }
    };
    const validateFun2 = (rule, value, callback) => {
      if (!value) {
        this.timeMsg = "";
      } else {
        this.checkTime2 = moment(value).format("YYYY-MM-DD HH:mm:ss");
        if (this.meetingId !== "") {
          const query = {
            meetingId: this.meetingId,
            startTime: this.checkTime,
            endTime: this.checkTime2
          };
          findMeetingTime(query).then(res => {
            // if (res.msg === "success" || res.msg !== "") {
            //   callback();
            // }
            if (Number(res.code) === 1000) {
              this.timeMsg = res.msg;
            } else {
              this.timeMsg = "";
              callback();
            }
          });
        }
      }
    };
    const validatePhone = (rule, value, callback) => {
      // 定义规则
      const reg = /^1[345789]\d{9}$/;
      if (value !== "" && reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    };
    return {
      ruleForm: {
        appointmenter: "",
        theme: "",
        // date: '',
        date1: "",
        date2: "",
        department: "",
        telephone: ""
        // desc: ''
      },
      rules: {
        appointmenter: [
          { required: true, message: "请输入预约人", trigger: "blur" }
        ],
        theme: [{ required: true, message: "请输入会议主题", trigger: "blur" }],
        date1: [
          { required: true, message: "请选择时间", trigger: "blur" },
          {
            // 对应item-prop
            validator: validateFun1, // 对应上方规则
            trigger: "change" // 修改验证
          }
        ],
        date2: [
          { required: true, message: "请选择时间", trigger: "blur" },
          {
            // 对应item-prop
            validator: validateFun2, // 对应上方规则
            trigger: "change" // 修改验证
          }
        ],
        department: [
          { required: true, message: "请输入主办单位", trigger: "blur" }
        ],
        telephone: [
          { required: true, message: "请输入预约人电话", trigger: "blur" },
          {
            validator: validatePhone,
            message: "请输入正确的电话号码",
            trigger: "change"
          }
        ]
      },
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        }
      },
      appointments: [],
      appointments2: [],
      appointmenterString: "",
      addAppoint: {
        name: "",
        telephone: "",
        personType: 2
      },
      fonts: "",
      nextWeektrue: true,
      roomList: [],
      roomlistActive: 0,
      roomActiveName: "",
      timeData: [],
      aweeklater: new Date(new Date().getTime() + 6 * 24 * 3600 * 1000),
      twoweeklater: new Date(new Date().getTime() + 12 * 24 * 3600 * 1000),
      appointVisible: false,
      innerVisible: false,
      innerVisible2: false,
      timeActive: 0,
      headData: [
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00",
        "24:00"
      ],
      originheadData: [
        {
          name: "01:00"
        },
        { name: "02:00" },
        { name: "03:00" },
        { name: "04:00" },
        { name: "05:00" },
        { name: "06:00" },
        { name: "07:00" },
        { name: "08:00" },
        { name: "09:00" },
        { name: "10:00" },
        { name: "11:00" },
        { name: "12:00" },
        { name: "13:00" },
        { name: "14:00" },
        { name: "15:00" },
        { name: "16:00" },
        { name: "17:00" },
        { name: "18:00" },
        { name: "19:00" },
        { name: "20:00" },
        { name: "21:00" },
        { name: "22:00" },
        { name: "23:00" },
        { name: "24:00" }
      ],
      headData1: [],
      headData2: [],
      aready: false,
      nexttip: true,
      meetingId: "",
      divLeft: null,
      divRight: null,
      checkTime: "",
      checkTime2: "",
      timeMsg: "",
      timeClock: null,
      // addmeetingName: '',
      areadyChecktime: {
        checkDate: "",
        startTime: "",
        endTime: "",
        fromIndex: "",
        toIndex: "",
        oldkey: ""
      },
      bgUrl:''
    };
  },
  mounted() {
    let _this = this;
    this.getMeetingList();

    this.headData1 = this.headData2 = [...this.originheadData];

    this.divLeft = document.getElementsByClassName("weekbox")[0];
    this.divRight = document.getElementsByClassName("appointTable")[0];
    // console.log(divLeft)
    this.divLeft.addEventListener("scroll", this.scrollrightFun);
    this.divRight.addEventListener("scroll", this.scrollleftFun);

    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.bgUrl = localStorage.getItem('bgUrl')
    // console.log(this.meetingName);
    // this.timeClock = setInterval(() => {
    //   this.getMeetModels();
    // }, 2000);
  },
  beforeDestroy() {
    if (this.timer) {
      // clearInterval(this.timeClock);
    }
  },
  methods: {
    getMeetModels() {
      getMeetModel().then(res => {
        if (Number(res.code) === 0) {
          this.fonts = res.data.fontStyle;
        }
      });
    },
    scrollrightFun() {
      //当左边滚动，右边也跟着滚动
      this.divRight.scrollTop = this.divLeft.scrollTop;
    },
    scrollleftFun() {
      //当右边滚动，左边也跟着滚动
      this.divLeft.scrollTop = this.divRight.scrollTop;
    },
    getMeetingList() {
      let _this = this;
      let meetingName = {
        name: ""
      };
      meetingLists(meetingName).then(res => {
        if (Number(res.code) === 0) {
          _this.roomList = res.data;
          res.data.forEach((i, index) => {
            if (i.id == _this.meetingId) {
              _this.roomlistActive = index;
              _this.roomActiveName = i.name;
              _this.getTimeStatus(i.id, 1);
            }
          });
        }
      });
    },
    checkroom(index) {
      this.roomlistActive = index;
      this.meetingId = this.roomList[index].id;
      this.getTimeStatus(this.roomList[index].id, 1);
      this.roomActiveName = this.roomList[index].name;
    },
    getTimeStatus(id, state) {
      const statusData = {
        meetingId: id,
        startTime:
          state === 1
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(this.aweeklater).format("YYYY-MM-DD"),
        endTime:
          state === 1
            ? moment(this.aweeklater).format("YYYY-MM-DD")
            : moment(this.twoweeklater).format("YYYY-MM-DD")
      };
      timeStatus(statusData).then(res => {
        console.log(res);
        if (Number(res.code) === 0) {
          this.timeData = [];
          let num = 0;
          for (const i in res.data) {
            num++;
            this.timeData.push({
              index: num,
              formatedate: i,
              date:
                new Date(i).getMonth() +
                1 +
                "月" +
                new Date(i).getDate() +
                "日",
              day: this.getWeekName(i),
              freetime: res.data[i]
            });
          }
          // console.log(this.timeData)
        }
      });
    },
    getttimeStates(date) {
      //新建会议弹框中获取当天预约状态
      const statusData = {
        meetingId: this.meetingId,
        startTime: moment(date).format("YYYY-MM-DD"),
        endTime: moment(date).format("YYYY-MM-DD")
      };
      timeStatus(statusData).then(res => {
        console.log(res);
        if (Number(res.code) === 0) {
          let dateArray = Object.values(res.data);
          let copyoriginheadData = [...this.originheadData];
          for (let i in dateArray[0]) {
            if (Number(dateArray[0][i]) === 0) {
              copyoriginheadData[i].disabled = true;
            } else {
              copyoriginheadData[i].disabled = false;
            }
          }
          this.headData1 = this.headData2 = copyoriginheadData;
        }
      });
    },
    nextWeek() {
      this.getTimeStatus(this.roomList[0].id, 2);
      this.nextWeektrue = false;
    },
    beforeWeek() {
      this.getTimeStatus(this.roomList[0].id, 1);
      this.nextWeektrue = true;
    },
    selectTime(val) {
      if (!val) {
        this.timeMsg = "";
      } else {
        console.log(val);
        this.checkTime = moment(val).format("YYYY-MM-DD HH:mm:ss");
        if (this.meetingId !== "") {
          this.gettimeTaken();
        }
      }
    },
    selectTime2(val) {
      if (!val) {
        this.timeMsg = "";
      } else {
        this.checkTime2 = moment(val).format("YYYY-MM-DD HH:mm:ss");
        if (this.meetingId !== "") {
          this.gettimeTaken();
        }
      }
    },
    gettimeTaken() {
      const query = {
        meetingId: this.meetingId,
        startTime: this.checkTime,
        endTime: this.checkTime2
      };
      findMeetingTime(query).then(res => {
        if (Number(res.code) === 1000) {
          this.timeMsg = res.msg;
        } else {
          this.timeMsg = "";
        }
      });
    },
    getWeekName(date) {
      switch (new Date(date).getDay()) {
        case 0:
          return "星期日";
          break;
        case 1:
          return "星期一";
          break;
        case 2:
          return "星期二";
          break;
        case 3:
          return "星期三";
          break;
        case 4:
          return "星期四";
          break;
        case 5:
          return "星期五";
          break;
        case 6:
          return "星期六";
          break;
      }
    },
    labelHead(h, { column, index }) {
      const l = column.label.length;
      const f = 12; // 每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
      column.minWidth = f * l; // 字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
      // 然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h("span", { class: "table-head", style: { width: "100%" } }, [
        column.label
      ]);
    },
    nextStep() {
      this.appointVisible = true;
    },
    addAppointShow() {
      this.innerVisible2 = true;
    },
    appointAddfun() {
      const reg = /^1[345789]\d{9}$/;
      if (this.addAppoint.name === "") {
        // this.$message.warning("请输入姓名");
        Toastinit({
          time: 2000,
          message: "请输入姓名",
          type: "error"
        });
        return false;
      }
      if (
        this.addAppoint.telephone === "" ||
        !reg.test(this.addAppoint.telephone)
      ) {
        // this.$message.warning("请输入正确的电话");
        Toastinit({
          time: 2000,
          message: "请输入正确的电话",
          type: "error"
        });
        return false;
      }
      this.appointments2.push({
        attendeeName: this.addAppoint.name,
        attendeeTel: this.addAppoint.telephone,
        personType: 2
      });
      this.addAppoint.name = "";
      this.addAppoint.telephone = "";
    },
    deleteAppoint(index) {
      this.appointments2.splice(index, 1);
    },
    appointSubmit(formName) {
      // if (this.appointments2.length > 0) {
      const ruleDate = moment(this.ruleForm.date).format("YYYY-MM-DD");
      this.$refs[formName].validate(valid => {
        // console.log(valid)
        if (valid) {
          if (this.appointments2.length > 0) {
            const addorderdata = {
              appointmenter: this.ruleForm.appointmenter,
              meetingId: this.meetingId,
              telephone: this.ruleForm.telephone,
              theme: this.ruleForm.theme,
              department: this.ruleForm.department,
              attendance: this.appointments2,
              startTime: moment(this.ruleForm.date1).format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              endTime: moment(this.ruleForm.date2).format("YYYY-MM-DD HH:mm:ss")
            };
            console.log(addorderdata);
            addOrders(addorderdata).then(res => {
              console.log(res);
              if (Number(res.code) === 0) {
                this.getOrderDetail(addorderdata);
                this.appointVisible = false;
              } else {
                // this.$message.error(res.msg);
                Toastinit({
                  time: 2000,
                  message: res.msg,
                  type: "error"
                });
              }
            });
            // this.appointVisible = false
            // this.aready = true
            // this.nexttip = false
          } else {
            // this.$message.warning("参会人不能为空");
            Toastinit({
              time: 2000,
              message: "参会人不能为空",
              type: "error"
            });
          }
        }
      });
    },
    getOrderDetail(data) {
      const presentData = {
        appointmenter: data.appointmenter,
        meetingId: data.meetingId,
        theme: data.theme,
        startTime: data.startTime,
        endTime: data.endTime
      };
      atPresent(presentData).then(res => {
        console.log(res);
        if (Number(res.code) === 0) {
          this.$router.push({
            path: "/OrderSuccess",
            query: { detail: res.data, equipmentName: this.equipmentName }
          });
        }
      });
    },
    checkappointdate(val) {
      console.log(val);
      if (val && val !== "") {
        const checkDate = new Date(val);
        this.getttimeStates(checkDate);
      } else {
        let copyData = [...this.originheadData];
        copyData.forEach(item => {
          item.disabled = false;
        });
        this.headData1 = this.headData2 = [...copyData];
      }
    },
    submitAppointment() {
      if (this.appointments2.length > 0) {
        this.innerVisible2 = false;
        this.appointmenterString = "";
        this.appointments2.forEach(item => {
          this.appointmenterString += item.attendeeName + ",";
        });
      } else {
        // this.$message.warning("参会人不能为空");
        Toastinit({
          time: 2000,
          message: "参会人不能为空",
          type: "error"
        });
      }
    },
    finalappointSubmit() {
      this.$router.push({ path: "/OrderSuccess" });
    },
    changeF(font) {
      this.fonts = font;
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  // padding: 6% 10%;
  font-size: 36px;
  .appointbox {
    padding: 1%;
    display: flex;
    height: 86%;
    .appointleft {
      flex: 1;
      overflow: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      li {
        background: radial-gradient(
          rgba(255, 255, 255, 0.2) 60%,
          rgba(255, 255, 255, 0.4) 100%
        );
        margin-bottom: 10px;
        border-radius: 16px;
        text-align: center;
        padding: 10% 1%;
        font-size: 24px;
        position: relative;
        overflow: hidden;
        .navbtn {
          width: 58px;
          height: 57px;
        }
        .righttop {
          display: none;
          position: absolute;
          top: 0;
          right: 0;
          .triangle {
            position: absolute;
            top: 0;
            right: 0;
            border-top: 85px solid #ffb668;
            border-left: 85px solid transparent;
            border-right: 0 solid transparent;
          }
          img {
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 10;
            width: 37px;
            height: 26px;
          }
        }
      }
      li.active {
        .righttop {
          display: block;
        }
      }
    }
    .appointleft::-webkit-scrollbar {
      display: none;
    }
    .appointright {
      flex: 7;
      // display: flex;
      margin-left: 20px;
      border-radius: 10px;
      overflow: hidden;
      .weekleft {
        // flex: 1;
        position: relative;
        display: inline-block;
        width: 10%;
        height: 100%;
        background: rgba(255, 255, 255, 0.2);
        .timetitle {
          color: #ffb668;
          font-size: 36px;
          text-align: center;
          padding: 10% 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        .weekbox {
          height: 86%;
          overflow: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
          li {
            text-align: center;
            font-size: 22px;
            padding: 17.5% 0;
          }
          li.active {
            color: #ffb668;
          }
        }
        .weekbox::-webkit-scrollbar {
          display: none;
        }
        .nextweek {
          text-align: center;
          font-size: 24px;
          background-color: #405e7a;
          width: 100%;
          position: absolute;
          bottom: 0;
          padding: 5% 0;
        }
      }
      .weektime {
        // flex: 10;
        display: inline-block;
        width: 86%;
        height: 100%;
        vertical-align: top;
        overflow: hidden;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        .appointTable {
          overflow-x: auto;
          height: 94%;
          scrollbar-width: none;
          -ms-overflow-style: none;
          .timeheadli {
            float: left;
          }
          /deep/.el-table__body {
            div.cell {
              border: 1px solid #4c60a2;
            }
          }
          /deep/.el-table .cell {
            padding: 0;
          }
          /deep/.el-table__row > td {
            border: none;
          }
          /deep/.el-table th,
          /deep/.el-table tr {
            background-color: transparent;
            border: none;
          }
          /deep/.el-table td {
            padding: 0;
            .timestate {
              background: rgba(255, 255, 255, 0.3);
              padding: 17.5% 0;
              // display: inline-block;
            }
            .timestate.inavailable {
              background: rgba(0, 0, 0, 0.2);
            }
            .timestate.myMeeting {
              background: linear-gradient(to bottom, #b8edca, #7ee9c5);
            }
          }
          /deep/.el-table tr:hover td {
            background-color: transparent;
          }
          .el-table::before {
            height: 0;
          }
          /deep/.el-table,
          .el-table__expanded-cell {
            background-color: transparent;
          }
        }
        .appointTable::-webkit-scrollbar {
          display: none;
        }
      }
      .appointBottom {
        padding: 1% 0;
        background: rgba(255, 255, 255, 0.2);
        display: inline-block;
        width: 100%;
        .imgDemo {
          float: left;
          font-size: 24px;
          line-height: 30px;
          margin-left: 20px;
          span {
            display: inline-block;
            vertical-align: top;
            line-height: 30px;
          }
          span.timedemo {
            width: 25px;
            height: 25px;
            margin-right: 10px;
            margin-top: 6px;
          }
          span.inavailable {
            background: rgba(0, 0, 0, 0.2);
          }
          span.available {
            background: rgba(255, 255, 255, 0.3);
          }
          span.myMeeting {
            background: linear-gradient(to bottom, #b8edca, #7ee9c5);
          }
        }
      }
    }
    .nextStep,
    .aready {
      position: absolute;
      right: 2%;
      bottom: 2%;
      z-index: 10;
      width: 100px;
      height: 100px;
      text-align: center;
      background: url("../assets/next.png") no-repeat;
      background-size: 100% 100%;
      font-size: 30px;
      border-radius: 50%;
      line-height: 100px;
      // padding: 60px 0;
    }
  }
  /deep/.el-drawer__body {
    height: 100%;
    overflow: auto;
  }
}

/*新建会议弹框*/
/deep/.el-drawer {
  background-color: transparent;
  .appointDrawer {
    color: #666;
    height: 100%;
    padding: 5%;
    overflow: auto;
    background-color: rgba(255, 255, 255, 0.5);
    // height: 100%;
    .appointCon {
      font-size: 30px;
      // background: url(../assets/recbg.png) no-repeat;
      background: #fff;
      border-radius: 20px;
      padding: 5%;
      background-size: 100% 100%;
      // height: 93%;
      .appointTitle {
        color: #333;
      }
      .centerline {
        width: 100%;
        margin: 0 auto;
        border-bottom: 1px dashed #ddd;
      }
      .meetingRoom {
        text-align: center;
        color: #666;
        padding: 5% 0;
      }
      .meetingCheck {
        padding-top: 5%;
        position: relative;
        overflow: hidden;
        /deep/.el-form-item__content {
          margin-bottom: 1.5%;
          .labelname {
            color: #343434;
            font-size: 30px;
            // margin-bottom: 0;
            // margin-top: 2%;
            img {
              margin-right: 3%;
            }
            span {
              vertical-align: top;
              display: inline-block;
              line-height: 40px;
              margin-right: 20px;
            }
          }
          .labelright {
            width: 100%;
            .line {
              text-align: center;
            }
            .picker-class {
              width: 100%;
            }
            /deep/.el-input__inner {
              font-size: 30px;
              border: none;
              border-bottom: 1px solid #9a9a9a;
              padding-left: 40px;
              padding-right: 15px;
            }
            /deep/.el-col {
              /deep/.el-input__inner {
                width: 100%;
                font-size: 20px;
              }
            }
            /deep/.el-input__icon {
              font-size: 30px;
            }
            /deep/.el-textarea__inner {
              font-size: 30px;
            }
          }
        }
        .addcheckappointmentlist {
          height: 80%;
          overflow: auto;
          position: absolute;
          top: 90px;
          bottom: 0;
          left: 0;
          right: 0;
          .noapenter {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #d9d9d9;
            font-size: 50px;
            text-align: center;
          }
        }
        .addcheckappointmentlist::-webkit-scrollbar {
          display: none;
        }
        .addappointmenterform {
          position: absolute;
          top: 20px;
          left: 0;
          right: 0;
        }
        .messageAppoint {
          border-bottom: 1px solid #9a9a9a;
          position: relative;
          height: 40px;
          font-size: 30px;
          line-height: 30px;
          i {
            position: absolute;
            right: 10px;
            top: 0;
            color: #2ad8fe;
            font-size: 27px;
          }
        }
        /deep/.el-form-item__error {
          font-size: 16px;
        }

        /*选择参会人*/
        li {
          width: 108px;
          float: left;
          position: relative;
          // margin: 16px;
          img {
            width: 108px;
            height: 108px;
          }
          .appointmentName {
            text-align: center;
            font-size: 20px;
          }
          /deep/.el-checkbox {
            position: absolute;
            right: 0;
            top: 0;
            /deep/.el-checkbox__inner {
              width: 25px;
              height: 25px;
            }
            /deep/.el-checkbox__inner::after {
              width: 11px;
              height: 15px;
              left: 5px;
            }
          }
        }
      }
      .addcheckappointment {
        height: 65%;
        li {
          float: none;
          height: auto;
          width: 100%;
          display: inline-block;
          /deep/.el-input__inner {
            font-size: 30px;
          }
          /deep/.el-button {
            font-size: 30px;
            width: auto;
            background-color: #409eff;
          }
        }
        .appointAddbtn {
          margin-left: 20px;
        }
      }
      .appointBtn {
        z-index: 10;
        width: 100px;
        height: 100px;
        text-align: center;
        background: url(../assets/next.png) no-repeat;
        background-size: 100% 100%;
        font-size: 30px;
        border-radius: 50%;
        line-height: 100px;
        margin: 0 auto;
        color: #fff;
      }
      .checkappointment {
        padding: 0 4%;
        height: 75%;
        overflow: auto;
      }
    }
  }
  .addappointDrawer {
    height: 100%;
    overflow: auto;
    .appointCon {
      height: 93%;
    }
  }
}
/deep/.el-date-table {
  font-size: 18px;
}
@media screen and (max-width: 1600px) {
  .bg .appointbox .appointright .weekleft .weekbox li {
    padding: 20% 0;
  }
}
@media screen and (max-width: 1500px) {
  .bg .appointbox .appointright .weekleft .weekbox li {
    padding: 22% 0;
  }
}
@media screen and (max-width: 1300px) {
  .bg .appointbox .appointright .weekleft .weekbox li {
    padding: 26% 0;
  }
}
@media screen and (max-width: 1100px) {
  .bg .appointbox .appointright .weekleft .weekbox li {
    padding: 32% 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/appoint.vue